import { PencilIcon, Trash2Icon } from 'lucide-react'
import type { ReactNode } from 'react'

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from '@/components/ui'

interface StatementMenuProps {
  children: ReactNode
  onEditRange: () => void
  // Left out where there is no statement to delete, only a pile of loose pages.
  onDelete?: () => void
}

// The right-click menu on a statement in the map.
export const StatementMenu = ({
  children,
  onEditRange,
  onDelete,
}: StatementMenuProps) => (
  <ContextMenu>
    <ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
    <ContextMenuContent>
      <ContextMenuItem onClick={onEditRange}>
        <PencilIcon className="size-4" />
        Edit statement range
      </ContextMenuItem>
      {onDelete ? (
        <>
          <ContextMenuSeparator />
          <ContextMenuItem onClick={onDelete} destructive>
            <Trash2Icon className="size-4" />
            Delete statement range
          </ContextMenuItem>
        </>
      ) : null}
    </ContextMenuContent>
  </ContextMenu>
)
